import { searchParamsToString, } from '@moderepo/mode-data-state-base';
import createCachedSelector from 're-reselect';
/**
 * This is the actual function that will get the data from the state and return the data requested. However, this function returns a new
 * object every time which can cause an infinite loop in re-rendering if used in React component. Therefore this function is not EXPORTED
 * and we will create another function below which use memoize to cache the result.
 */
const selectProjectDevicesFunc = (devicesById, deviceIdsByProjectId, projectId, searchParams) => {
    var _a;
    const dataSet = (_a = deviceIdsByProjectId[projectId]) === null || _a === void 0 ? void 0 : _a[searchParams];
    if (dataSet) {
        // This will return a new PaginationDataSet of ProjectDevice which can cause infinite loop if we don't use memoize
        return {
            range: dataSet.range,
            items: dataSet.items.reduce((result, deviceId) => {
                const device = devicesById[deviceId];
                if (device) {
                    return [
                        ...result,
                        device,
                    ];
                }
                return result;
            }, []),
        };
    }
    return undefined;
};
/**
 * Select ALL devices for a project. Technically we can use "state.devicesDataSetByProjectId.items" and map the deviceIds in the items array
 * to the actual ProjectDevice and return an array of those ProjectDevices. However, doing that will return a new array every time this function
 * is called. This will cause an infinite loop in the react render component.
 * So what this function does is instead of returning a new array of ProjectDevice, it return a Function that will do just that. However, this
 * Function will be memoized based on the devicesByProjectSelectors as cache key. So if this function is called multiple time but the data has not
 * changed, the cached result will be returned by "createSelector".
 */
export const selectProjectDevices = createCachedSelector((state) => { return state.projectDevices.devicesById; }, (state) => { return state.projectDevices.deviceIdsByProjectId; }, (state, projectId) => { return projectId; }, (state, projectId, searchParams) => { return searchParamsToString(searchParams); }, selectProjectDevicesFunc)((state, projectId, searchParams) => {
    // use searchParams as cache key for creatCachedSelector
    return searchParamsToString(searchParams);
});
/**
 * Return a device by device id
 * @param state
 * @param deviceId
 */
export const selectProjectDeviceById = (state, deviceId) => {
    return state.projectDevices.devicesById[deviceId];
};
